import { useNavigate } from "react-router-dom";
import Spinner from "../../Components/spinner";
import { ViewButton } from "../../helper/ImageFormat";
import dateformate from "../../helper/DateFormate";
import StatusBadge from "../../Components/StatusBadge";

const OrderList = ({ loading, data }) => {
    const navigator = useNavigate()
    const handleRedirect = (item) => {
        navigator(`/order/detail/${item?.orderId}`);
    }
    return (
        <div className="row ">
            <div className="col-md-12 grid-margin stretch-card">

                <div className="card">
                    <div className="card-body">
                        <h4>Recent orders</h4>
                        <div className="table-responsive">
                            <table
                                className=" custom-table table table-striped"
                                id="myTable"
                                style={{ marginTop: "3px" }}
                            >
                                <thead>
                                    <tr>
                                        <th>Order Id</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Payment Method</th>
                                        <th>Payment Status</th>
                                        <th>Email</th>
                                        <th>Date</th>
                                        <th>View</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="12" className="text-center">
                                                <Spinner />
                                            </td>
                                        </tr>
                                    ) : data.length > 0 ? (
                                        data.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item?.orderId}</td>
                                                <td>{item?.totalAmount?.toFixed(2)}</td>
                                                <td>
                                                <StatusBadge status={item?.status} />
                                                </td>

                                                <td>{item?.payment?.[0]?.paymentMethod}</td>
                                                 <td>
                                                <StatusBadge status={item?.payment?.[0]?.status} />
                                                </td>
                                                <td>{item?.user?.email}</td>
                                                <td>
                                                    {dateformate(item.createdAt)}
                                                </td>
                                                <td>
                                                    <ViewButton handleRedirect={() => { handleRedirect(item) }} id={data?.order?.orderId} />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="12" className="text-center">
                                                <h4>No data available</h4>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default OrderList